/**
 * The ownership form in words.
 *
 * Shared and not client-side, because the mail to bookkeeping states it too, and
 * `Eigendom: EIGEN` in a message to a person is the enum leaking out of the app.
 */
export const EIGENDOM_LABEL = {
    EIGEN: 'Eigen bezit',
    LEASE: 'Lease',
    LEEN: 'Leenauto',
};
/**
 * Whether a car is leased, i.e. whether its ownership form says so.
 *
 * This used to read a legacy free-text field from before the `eigendom` enum
 * existed. That field was empty on every car, so the function always returned
 * false: the dashboard's lease list stayed permanently empty and `ownedCount`
 * claimed every active car was owned, while the ownership ring — which does read
 * `eigendom` — showed the real split on the same page. The field is gone.
 */
export function isLease(car) {
    return car.eigendom === 'LEASE';
}
/**
 * Whether the car is ours to put a value on. A leased or borrowed car is not, so
 * it stays out of the fleet-value total: with lease the car belongs to the lease
 * company, and a loaner belongs to whoever lent it.
 */
export function isEigenBezit(car) {
    return car.eigendom === 'EIGEN';
}
//# sourceMappingURL=lease.js.map